'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/TextUnderline.es.js";
const o = a.forwardRef((r, t) => /* @__PURE__ */ a.createElement(p, { ref: t, ...r, weights: e }));
o.displayName = "TextUnderlineIcon";
const c = o;
export {
  c as TextUnderline,
  o as TextUnderlineIcon
};
